<template>
  <div style="">
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-row class="m-0">
        <!-- <b-col> </b-col> -->
        <b-col class="text-right">
          <downloadChart :commitName="'EU Consumer sentiment (RHS)'" />
        </b-col>
      </b-row>
      <b-row class="m-0 chartTabPanel autoCursor scroll50Panel mb-3">
        <b-col ref="capture">
          <b-row>
            <b-col cols="6" class="pb-5">
              <b-card ref="chartPanel">
                <template #header>
                  <b-row>
                    <b-col cols="4" class="p-0 pl-2"
                      ><h6 class="mb-0">EU vs. US CPI</h6></b-col
                    >
                    <b-col cols="8">
                      <div class="float-right">
                        <div class="filterText">Filter by Year:</div>
                      </div>
                    </b-col>
                    <b-col cols="12" class="p-0">
                      <b-col class="float-right w-75 ">
                        <div class="d-flex">
                          <b class="mr-3">{{
                            euvsuscpiSliderMinMaxValue[0]
                          }}</b>
                          <b-form-slider
                            v-if="
                              euvsuscpiSliderValue &&
                                euvsuscpiSliderValue.length
                            "
                            class="w-100 p-0 pr-2"
                            ref="mySlider"
                            :value="euvsuscpiSliderValue"
                            :min="euvsuscpiSliderValue[0]"
                            :max="euvsuscpiSliderValue[1]"
                            :range="slider_range"
                            @slide-stop="
                              slideChange('euvsuscpiDataValue', $event)
                            "
                          ></b-form-slider>
                          <b class="ml-3">{{
                            euvsuscpiSliderMinMaxValue[1]
                          }}</b>
                        </div>
                      </b-col>
                    </b-col>
                  </b-row>
                </template>
                
                <Plotly
                  :data="euvsuscpiDataValue"
                  :layout="linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
            <b-col cols="6" class="pb-5">
              <b-card ref="chartPanel">
                <template #header>
                  <b-row>
                    <b-col cols="4" class="p-0 pl-2">
                      <h6 class="mb-0">Consumer Sentiment</h6>
                    </b-col>
                    <b-col cols="8">
                      <div class="float-right">
                        <div class="filterText">Filter by Year:</div>
                      </div>
                    </b-col>
                    <b-col cols="12" class="p-0">
                      <b-col class="float-right w-75 ">
                        <div class="d-flex">
                          <b class="mr-3">{{
                            consumersentimentSliderMinMaxValue[0]
                          }}</b>
                          <b-form-slider
                            v-if="
                              consumersentimentSliderValue &&
                                consumersentimentSliderValue.length
                            "
                            class="w-100 p-0 pr-2"
                            ref="mySlider"
                            :value="consumersentimentSliderValue"
                            :min="consumersentimentSliderValue[0]"
                            :max="consumersentimentSliderValue[1]"
                            :range="slider_range"
                            @slide-stop="
                              slideChange('consumersentimentDataValue', $event)
                            "
                          ></b-form-slider>
                          <b class="ml-3">{{
                            consumersentimentSliderMinMaxValue[1]
                          }}</b>
                        </div>
                      </b-col>
                    </b-col>
                  </b-row>
                </template>
                <Plotly
                  :data="consumersentimentDataValue"
                  :layout="linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import bFormSlider from "vue-bootstrap-slider/es/form-slider";
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "CPI_and_Sentiments",
  components: {
    Plotly,
    bFormSlider,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      cpiandsentiments: "cpiandsentiments",
      euvsuscpi: "euvsuscpi",
      isFullScreen: "isFullScreen",
    }),
  },
  data() {
    return {
      chartTitle: "",
      slider_range: true,
      linelayout: {
        width: "500",
        height: 350,
        autosize: true,
        margin: {
          l: "50",
          r: "30",
          b: 100,
          t: 30,
          pad: 0,
        },
        xaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
          showspikes: false,
        },
        yaxis: {
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [-0.06, 0.08],
          nticks: 8,
          tickformat: "%",
        },

        legend: {
          x: 0,
          y: -0.2,
          orientation: "h",
        },
      },
      config: { responsive: true },
      consumersentimentSliderValue: [],
      consumersentimentSliderMinMaxValue: [],
      euvsuscpiSliderValue: [],
      euvsuscpiSliderMinMaxValue: [],
      min: 2018,
      max: 2021,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      cpiandsentimentsClone: [],
      consumersentimentDataValue: [],
      euvsuscpiDataValue: [],
    };
  },
  created() {
    window.addEventListener("resize", this.windowResize);
    // console.log('this.$refs.capture-=-=-',this.$refs);
    // this.setDownloadInfo({'fileName':"CPI_and_Sentiment","downloadData":this.$refs.capture});
  },
  methods: {
    ...mapActions([
      "setDownloadInfo",
      "getChartDataById",
      "getIframeChartDataById",
    ]),
    windowResize(e) {
      // console.log('check width-=-=',this.$refs.chartPanel.clientWidth);
      this.linelayout.width = this.$refs.chartPanel.clientWidth - 100;
    },
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },
    slideChange(data, $event) {
      if (this.cpiandsentimentsClone) {
        if (data == "consumersentimentDataValue") {
          this.consumersentimentData();
          this.consumersentimentSliderMinMaxValue = $event;
        } else {
          this.euvsuscpiData();
          this.euvsuscpiSliderMinMaxValue = $event;
        }
      }
      let e = $event;
      var chartData = this[data];
      let fullData = [];
      let chartName = "";
      for (let y = 0; y < chartData.length; y++) {
        chartName = chartName + chartData[y].name;
        let filterData = { x: [], y: [], measure: [], text: [] };
        for (let i = 0; i < chartData[y].x.length; i++) {
          if (
            chartData[y] &&
            chartData[y].x &&
            chartData[y].x[i] &&
            parseInt(chartData[y].x[i].split("-")[0]) >= parseInt(e[0]) &&
            parseInt(chartData[y].x[i].split("-")[0]) <= parseInt(e[1])
          ) {
            filterData.x.push(chartData[y].x[i]);
            filterData.y.push(chartData[y].y[i]);
          }
        }
        this.updateChartData(chartName, y, filterData);
        fullData.push(filterData);
      }
    },
    updateChartData(chartName, index, filterData) {
      if (
        chartName.includes("EU Capital goods % YoY") ||
        chartName.includes("US Capital % YoY")
      ) {
        this.euvsuscpiDataValue[index].x = filterData.x;
        this.euvsuscpiDataValue[index].y = filterData.y;
      } else if (
        chartName.includes("US Consumer sentiment (LHS)") ||
        chartName.includes("EU Consumer sentiment (RHS)")
      ) {
        this.consumersentimentDataValue[index].x = filterData.x;
        this.consumersentimentDataValue[index].y = filterData.y;
      }
    },
    async chartData() {
      let data = await this.getIframeChartDataById(67);
      // console.log("dataaaaaa", data);
      this.cpiandsentimentsClone = data;
      if (this.cpiandsentimentsClone) {
        this.euvsuscpiData();
        this.consumersentimentData();
        if (this.cpiandsentimentsClone.year.length) {
          this.sliderRangeValue(true);
          this.sliderRangeValue(false);
        }
      }
    },
    spliceData(data, key, chartKey) {
      if (data) {
        data[key].splice(data[chartKey].length ? data[chartKey].length : 1 - 1);
      }
      return data;
    },
    sliderValue(data) {
      let value = data.sort();
      value = [value[0], value[value.length - 1]];
      return value;
    },
    sliderRangeValue(val) {
      if (val) {
        if (this.cpiandsentimentsClone.year.length) {
          let data = JSON.parse(JSON.stringify(this.cpiandsentimentsClone));
          data = this.spliceData(data, "year", "eu_capital");
          let range = this.sliderValue(data.year);
          this.euvsuscpiSliderValue = range;
          this.euvsuscpiSliderMinMaxValue = range;
        }
      } else {
        if (this.cpiandsentimentsClone.year.length) {
          let data = JSON.parse(JSON.stringify(this.cpiandsentimentsClone));
          data = this.spliceData(data, "year", "eu_consumer_sentiment");
          let range = this.sliderValue(data.year);
          this.consumersentimentSliderValue = range;
          this.consumersentimentSliderMinMaxValue = range;
        }
      }
    },
    euvsuscpiData() {
      if (this.cpiandsentimentsClone) {
        // let data = JSON.parse(JSON.stringify(this.cpiandsentimentsClone));
        // data = this.spliceData(data, "year", "eu_capital");
        // data = this.spliceData(data, "date", "eu_capital");
        // let formattedData = {
        //   lineField: data.eu_capital,
        //   lineField1: data.us_capital,
        //   xField: data.date,
        //   year: data.year,
        // };
        // let trace1 = {
        //   type: "scatter",
        //   mode: "lines",
        //   name: "US Capital % YoY",
        //   x: formattedData.xField,
        //   y: formattedData.lineField1,
        //   year: formattedData.year,
        //   xaxis: "x",
        //   yaxis: "y",
        //   line: {
        //     shape: "spline",
        //     smoothing: 1.3,
        //     color: "#52bcd3",
        //   },
        // };
        // let trace2 = {
        //   type: "scatter",
        //   mode: "lines",
        //   name: "EU Capital goods % YoY",
        //   x: formattedData.xField,
        //   y: formattedData.lineField,
        //   year: formattedData.year,
        //   xaxis: "x",
        //   yaxis: "y",
        //   line: {
        //     shape: "spline",
        //     smoothing: 1.3,
        //     color: "#e9cd90",
        //   },
        // };
        // let consumersentimentData = [trace1, trace2];
        // this.euvsuscpiDataValue = [];
        let consumersentimentData = this.prepeareChartData("capital");
        this.euvsuscpiDataValue = consumersentimentData;
      }
    },
    consumersentimentData() {
      if (this.cpiandsentimentsClone) {
        // let data = JSON.parse(JSON.stringify(this.cpiandsentimentsClone));
        // data = this.spliceData(data, "year", "eu_consumer_sentiment");
        // data = this.spliceData(data, "date", "eu_consumer_sentiment");
        // let formattedData = {
        //   lineField: data.eu_consumer_sentiment,
        //   lineField1: data.us_consumer_sentiment,
        //   xField: data.date,
        //   year: data.year,
        // };
        // let trace1 = {
        //   type: "scatter",
        //   mode: "lines",
        //   name: "EU Consumer sentiment (RHS)",
        //   x: formattedData.xField,
        //   y: formattedData.lineField1,
        //   year: formattedData.year,
        //   xaxis: "x",
        //   yaxis: "y",
        //   line: {
        //     shape: "spline",
        //     smoothing: 1.3,
        //     color: "#52bcd3",
        //   },
        // };
        // let trace2 = {
        //   type: "scatter",
        //   mode: "lines",
        //   name: "US Consumer sentiment (LHS)",
        //   x: formattedData.xField,
        //   y: formattedData.lineField,
        //   year: formattedData.year,
        //   xaxis: "x",
        //   yaxis: "y",
        //   line: {
        //     shape: "spline",
        //     smoothing: 1.3,
        //     color: "#e9cd90",
        //   },
        // };
        // let sentimentData = [trace1, trace2];
        let sentimentData = this.prepeareChartData("consumer_sentiment");
        this.consumersentimentDataValue = sentimentData;
      }
    },
    prepeareChartData(key) {
      let data = JSON.parse(JSON.stringify(this.cpiandsentimentsClone));
      let keyVal_eu = "eu_" + key;
      let keyVal_us = "us_" + key;
      // console.log("0000000000000", data);
      data = this.spliceData(data, "year", keyVal_eu);
      data = this.spliceData(data, "date", keyVal_eu);
      let chartName1 = "";
      let chartName2 = "";
      if (keyVal_eu === "eu_consumer_sentiment") {
        chartName1 = "EU Consumer sentiment (RHS)";
        chartName2 = "US Consumer sentiment (LHS)";
      } else {
        chartName1 = "EU Capital goods % YoY";
        chartName2 = "US Capital goods % YoY";
      }
      let formattedData = {
        lineField: data[keyVal_eu],
        lineField1: data[keyVal_us],
        xField: data.date,
        year: data.year,
      };
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: chartName1,
        x: formattedData.xField,
        y: formattedData.lineField1,
        year: formattedData.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          shape: "spline",
          smoothing: 1.3,
          color: "#52bcd3",
        },
      };
      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: chartName2,
        x: formattedData.xField,
        y: formattedData.lineField,
        year: formattedData.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          shape: "spline",
          smoothing: 1.3,
          color: "#e9cd90",
        },
      };
      let sentimentData = [trace1, trace2];
      // this.consumersentimentDataValue = sentimentData;
      return sentimentData;
    },
  },
  mounted() {
    this.setDownloadInfo({
      fileName: "CPI_and_Sentiment",
      downloadData: this.$refs.capture,
    });
    this.chartData();
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
  watch: {
    cpiandsentiments: {
      deep: true,
      handler() {
        if (this.cpiandsentiments) {
          this.cpiandsentimentsClone = this.cpiandsentiments
            ? this.cpiandsentiments
            : [];
          this.euvsuscpiData();
          this.consumersentimentData();
          if (this.cpiandsentimentsClone.year.length) {
            this.sliderRangeValue(true);
            this.sliderRangeValue(false);
          }
        }
      },
    },
  },
};
</script>

<style lang="scss">
.salesContainer {
  position: relative;
}
.card-header .slider.slider-horizontal {
  width: calc(100% - 100px);
  height: 20px;
}
.card-body {
  padding: 0 !important;
}
</style>
